import {
  // Float,
  HStack,
  MenuItemProps,
  Stack,
  Text,
} from '@chakra-ui/react'

import { AlertCheckIcon, ArrowDownIcon } from '@/components/icon/generated'
import {
  Box,
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuSeparator,
  MenuTrigger,
} from '@/components/ui'
import { useQuerySuspense } from '@/lib/api'
import {
  AuthenticatedUser,
  fetchTOTPEnabled,
  useAuthenticatedUser,
} from '@/lib/auth'
import { getFullName } from '@/utils/getFullName'

import { ChangePasswordDialog } from './ChangePasswordDialog'
import { LogoutDialog } from './LogoutDialog'
import { MFADialog } from './MFADialog'

type UserProfileProps = {
  user: AuthenticatedUser
}

const UserProfile = ({ user }: UserProfileProps) => {
  return (
    <HStack px={4} py={2} gap={4} w="full">
      <Stack gap={1} w="full">
        <Text fontSize="sm" lineBreak="anywhere">
          {user.organizationName}
        </Text>
        <Box>
          <Text
            fontWeight="bold"
            overflow="hidden"
            maxW="full"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {getFullName(user.generalUser)}
          </Text>
          <Text as="small" fontSize="sm" lineBreak="anywhere">
            {user.generalUser.email}
          </Text>
        </Box>
      </Stack>
    </HStack>
  )
}

const UserMenuItem = (props: MenuItemProps) => {
  return <MenuItem px={4} py={2} cursor="pointer" {...props} />
}

export const UserMenu = () => {
  const user = useAuthenticatedUser()
  const { data: isTOTPEnabled } = useQuerySuspense(
    'totp-enabled',
    fetchTOTPEnabled,
  )
  return (
    <MenuRoot positioning={{ placement: 'bottom-end' }} closeOnSelect={false}>
      <MenuTrigger cursor="pointer">
        <HStack p={2} gap={4}>
          <Text
            color="gray.700"
            maxW={{ base: '16', desktop: '64' }}
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
          >
            {getFullName(user.generalUser)}
          </Text>
          <ArrowDownIcon color="gray.800" />
        </HStack>
      </MenuTrigger>

      <MenuContent color="text.main" minW="240px" maxW="320px" px={0} py={4}>
        <UserProfile user={user} />
        <MenuSeparator my={3} />
        <Stack px={4} gap={2}>
          <ChangePasswordDialog
            trigger={
              <UserMenuItem color="text.main" value="settings">
                パスワード変更
              </UserMenuItem>
            }
          />
          <MFADialog
            trigger={
              <UserMenuItem color="text.main" value="profile">
                <HStack>
                  <span>2段階認証</span>
                  {isTOTPEnabled && (
                    <Box color="status.success">
                      <AlertCheckIcon />
                    </Box>
                  )}
                </HStack>
              </UserMenuItem>
            }
          />
          <LogoutDialog
            trigger={
              <UserMenuItem color="text.danger" value="logout">
                ログアウト
              </UserMenuItem>
            }
          />
        </Stack>
      </MenuContent>
    </MenuRoot>
  )
}
